import { jsx as a } from "react/jsx-runtime";
import { l as o } from "../../logo-aXi6132f.js";
import '../../assets/style7.css';/* empty css                   */
const m = () => /* @__PURE__ */ a("div", { className: "loading-background", children: /* @__PURE__ */ a("div", { className: "loading-img-container", children: /* @__PURE__ */ a("img", { width: 75, src: o, alt: "minohealth logo", className: "spin" }) }) });
export {
  m as default
};
